import { render } from "./BrandResources.vue?vue&type=template&id=4b6ebc02"
import script from "./BrandResources.vue?vue&type=script&lang=js"
export * from "./BrandResources.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3529439572/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__